import { useEffect } from 'react';

const ChatbotWidget = () => {
  useEffect(() => {
    const iframe = document.createElement('iframe');
    iframe.src = 'https://samuelandsasha.github.io/WonderKidsAcademy/';
    iframe.style.border = 'none';
    iframe.style.position = 'fixed';
    iframe.style.bottom = '0';
    iframe.style.right = '0';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.maxWidth = '500px';
    iframe.style.maxHeight = '600px';
    iframe.style.zIndex = '2147483647';
    document.body.appendChild(iframe);

    const toggleBtn = document.createElement('button');
    toggleBtn.id = 'chatbot-toggle';
    Object.assign(toggleBtn.style, {
      position: 'fixed',
      bottom: '10px',
      right: '480px',
      backgroundColor: '#082c54',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '70px',
      height: '70px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      cursor: 'pointer',
      zIndex: '2147483646',
    });

    const img = document.createElement('img');
    img.src = 'https://scaledaycares.github.io/chatIcon/toggleimg.png';
    img.style.width = '50px';
    img.style.height = '50px';
    toggleBtn.appendChild(img);
    document.body.appendChild(toggleBtn);

    const closeButton = document.createElement('button');
    closeButton.id = 'chatbot-close';
    Object.assign(closeButton.style, {
      position: 'fixed',
      bottom: '420px',
      right: '35px',
      fontSize: '15px',
      width: '24px',
      height: '24px',
      backgroundColor: 'black',
      border: 'none',
      borderRadius: '50%',
      cursor: 'pointer',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: '2147483647',
      color: 'white',
      display: 'none',
    });
    closeButton.textContent = 'X';
    document.body.appendChild(closeButton);

    let chatbotIsOpen = localStorage.getItem('chatbotIsOpen');
    chatbotIsOpen = chatbotIsOpen === null ? true : chatbotIsOpen === 'true';

    const updateChatbotVisibility = () => {
      iframe.style.display = chatbotIsOpen ? 'flex' : 'none';
      closeButton.style.display = chatbotIsOpen ? 'flex' : 'none';
      localStorage.setItem('chatbotIsOpen', chatbotIsOpen);
    };

    const updateToggleBtnPosition = () => {
      toggleBtn.style.right = window.innerWidth <= 768 ? '20px' : '450px';
    };

    const resizeChatbot = () => {
      if (window.innerWidth <= 400) {
        iframe.style.width = '150%';
        iframe.style.height = '100%';
        iframe.style.right = '-50px';
        iframe.style.transform = 'scale(0.8)';
        Object.assign(closeButton.style, {
          bottom: '445px',
          right: '20px',
          fontSize: '18px',
          width: '30px',
          height: '30px',
        });
      } else if (window.innerWidth <= 768) {
        iframe.style.width = '110%';
        iframe.style.transform = 'scale(0.85)';
        iframe.style.transformOrigin = 'bottom right';
        Object.assign(closeButton.style, {
          bottom: '415px',
          right: '20px',
          fontSize: '18px',
          width: '17px',
          height: '17px',
        });
      } else {
        iframe.style.transform = 'scale(1)';
        closeButton.style.bottom = '490px';
      }
    };

    toggleBtn.addEventListener('click', () => {
      chatbotIsOpen = !chatbotIsOpen;
      updateChatbotVisibility();
    });

    closeButton.addEventListener('click', () => {
      chatbotIsOpen = false;
      updateChatbotVisibility();
    });

    window.addEventListener('message', (event) => {
      if (event.data && event.data.action) {
        console.log('Received message:', event.data.action);
        if (event.data.action === 'openCalendly') {
          closeButton.style.display = 'none';
        } else if (event.data.action === 'closeCalendly') {
          closeButton.style.display = 'flex';
        } else if (event.data.action === 'closeChatbot') {
          chatbotIsOpen = false;
          updateChatbotVisibility();
        }
      }
    });

    window.addEventListener('resize', () => {
      updateToggleBtnPosition();
      resizeChatbot();
    });

    updateToggleBtnPosition();
    updateChatbotVisibility();
    resizeChatbot();

    // Cleanup when component unmounts
    return () => {
      iframe.remove();
      toggleBtn.remove();
      closeButton.remove();
    };
  }, []);

  return null; 
};

export default ChatbotWidget;
